"use strict";
// Copyright (C) 2017-2025 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var routes_1 = __importDefault(require("stremio/routes"));
var getBackFallback_1 = require("./getBackFallback");
exports.default = [
    {
        path: '/intro',
        view: 1,
        element: react_1.default.createElement(react_router_dom_1.Navigate, { to: "/caroline-auth", replace: true }),
    },
    {
        path: '/caroline-auth',
        view: 1,
        element: react_1.default.createElement(routes_1.default.CarolineAuth, null),
    },
    {
        path: '/device',
        view: 1,
        element: react_1.default.createElement(routes_1.default.CarolineDeviceAuthorization, null),
    },
    {
        path: '/clesioadmin',
        view: 1,
        element: react_1.default.createElement(routes_1.default.CarolineAdmin, null),
    },
    {
        path: '/discover/:transportUrl?/:type?/:catalogId?',
        view: 1,
        element: react_1.default.createElement(routes_1.default.Discover, null),
    },
    {
        path: '/library/:type?',
        view: 1,
        element: react_1.default.createElement(routes_1.default.Library, null),
    },
    {
        path: '/calendar/:year?/:month?',
        view: 1,
        element: react_1.default.createElement(react_router_dom_1.Navigate, { to: "/", replace: true }),
    },
    {
        path: '/continuewatching/:type?',
        view: 1,
        element: react_1.default.createElement(routes_1.default.Library, null),
    },
    {
        path: '/search',
        view: 1,
        element: react_1.default.createElement(routes_1.default.Search, null),
    },
    {
        path: getBackFallback_1.META_DETAILS_PATH,
        view: 2,
        element: react_1.default.createElement(routes_1.default.MetaDetails, null),
    },
    {
        path: getBackFallback_1.LEGACY_META_DETAILS_PATH,
        view: 2,
        element: react_1.default.createElement(routes_1.default.MetaDetails, null),
    },
    {
        path: '/addons/:type?/:transportUrl?/:catalogId?',
        view: 3,
        element: react_1.default.createElement(react_router_dom_1.Navigate, { to: "/", replace: true }),
    },
    {
        path: '/settings',
        view: 3,
        element: react_1.default.createElement(routes_1.default.Settings, null),
    },
    {
        path: getBackFallback_1.PLAYER_PATH,
        view: 4,
        element: react_1.default.createElement(routes_1.default.Player, null),
    },
    {
        path: getBackFallback_1.LEGACY_PLAYER_PATH,
        view: 4,
        element: react_1.default.createElement(routes_1.default.Player, null),
    },
    {
        path: '/',
        view: 0,
        element: react_1.default.createElement(routes_1.default.Board, null),
    },
    {
        path: '*',
        view: 1,
        element: react_1.default.createElement(routes_1.default.NotFound, null),
    },
];
